import { Box, Grid, Stack, Switch } from '@mui/material';
import { useState, useEffect } from 'react';
import { FormProvider, Controller, useForm } from 'react-hook-form';
import {
  getDataDownloadSettings,
  IJobsDownloadTemplate,
  saveCandidateDownloadTemplaes,
} from 'wisestep-api';
import { WsButton, WsDialog } from 'wisestep-base';

import SaveTemplateDialog from '../../../../..//features/jobs/listing/components/Download/SaveTemplateDialog';
import { success, warning } from '../../../../..//utils/NotificationMessages';
import { useNotificationStore } from '../../../../..//utils/NotificationStore';
import { DrawerFooter } from '../../../../../components/filters/components/AdvanceFilterFooterBar';
import FormSwitchLayout from '../../../../../features/careerPageSettings/components/formSwitchLayout';
import {
  fieldsAvailable,
  fieldsObject,
  fieldsAvailableType,
  defaultValues,
} from '../../../../../features/crmSettings/dataDownloadSettings/downloadSettings/helper';

import CandidateDownloadTemplates from './CandidateDownloadTemplates';
interface DownloadProps {
  selectedFields: (v: string[]) => void;
  close(): void;
}
const DownloadField = ({ selectedFields, close }: DownloadProps) => {
  const [fields, setFields] = useState(fieldsObject);
  const [dataDownloadSettingsData, setDataDownloadSettingsData] =
    useState<IJobsDownloadTemplate>(defaultValues);
  const formDefaultValues = fields;
  const formOptions = {
    defaultValues: formDefaultValues,
  };
  const methodsMain = useForm(formOptions);
  const { handleSubmit, setValue, control, reset, getValues } = methodsMain;
  const setNotification = useNotificationStore((state) => state.setNotification);

  useEffect(() => {
    const fetchDataDownloadSettings = async () => {
      const getDataDownloadSettingsRes = await getDataDownloadSettings();

      if (getDataDownloadSettingsRes?.data.allowedColumns) {
        setDataDownloadSettingsData(getDataDownloadSettingsRes.data);
      } else {
        const tempData = getDataDownloadSettingsRes.data;
        tempData.allowedColumns = [
          'Candidate Name',
          'Candidate Email',
          'Candidate Phone',
          'LinkedIn URL',
          'Source',
          'Tags',
          'Current Country',
          'Current Continent',
          'Current Location',
          'Nationality',
        ];
        setDataDownloadSettingsData({ ...tempData });
      }
    };
    fetchDataDownloadSettings();
  }, []);
  useEffect(() => {
    const json = fieldsAvailable.reduce((json, value) => {
      json[value] = dataDownloadSettingsData?.allowedColumns.indexOf(value) != -1;
      return json;
    }, fieldsObject);
    if (json) setFields(json);
    reset(json);
  }, [dataDownloadSettingsData?.allowedColumns, reset]);

  const arr: string[] = [];
  const [open, setOpen] = useState<boolean>(false);

  const saveTemplate = async (name: string) => {
    if (name) {
      const allowedColumns: string[] = [];
      const data = getValues();
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          allowedColumns.push(key);
        }
      });
      try {
        const tempData: IJobsDownloadTemplate = {
          id: '',
          dataType: 'CandidateCRM',
          name: name ?? '',
          recruiterId: '',
          workspaceId: '',
          allowedColumns: allowedColumns ?? [],
          isAdmin: false,
          recordsDownloadLimit: 2000,
          downloadCcEmail: '',
          isHidden: false,
          isFavorite: false,
        };
        await saveCandidateDownloadTemplaes(tempData);
        setNotification(success('Attributes settings applied successfully'));
      } catch (error) {
        setNotification(warning('Something Went Wrong , Please try again'));
      }
    } else {
      setNotification(warning('Template Name is Mandatory please Enter'));
    }
  };
  const getText = (e) => {
    if (e == 'Current Job Title') {
      return 'Latest Job Title';
    } else {
      return e;
    }
  };
  return (
    <FormProvider {...methodsMain}>
      <Grid container xs={12} gap={1} m={1}>
        {fields &&
          fieldsAvailable.map((e: fieldsAvailableType) => (
            <FormSwitchLayout
              key={e}
              label={getText(e)}
              gridValue={5.8}
              border="solid"
              justifyContent="space-between"
            >
              <Box pt={1}>
                <Controller
                  name={e}
                  control={control}
                  render={(props) => (
                    <Switch
                      checked={props.field.value}
                      onChange={() => setValue(e, !props.field.value)}
                    />
                  )}
                />
              </Box>
            </FormSwitchLayout>
          ))}
      </Grid>
      <DrawerFooter>
        <Stack p={1} columnGap={2} direction="row" justifyContent="space-between">
          <Grid item container columnGap={1}>
            <WsButton variant="contained" size="large" onClick={() => setOpen(true)}>
              Save Template
            </WsButton>
            <CandidateDownloadTemplates
              selectedFields={(d) => {
                dataDownloadSettingsData.allowedColumns = d.allowedColumns;
                setDataDownloadSettingsData({ ...dataDownloadSettingsData });
              }}
            />
          </Grid>
          <WsButton
            variant="contained"
            size="large"
            onClick={handleSubmit((d) => {
              Object.entries(d).forEach(([key, value]) => {
                if (value) arr.push(key);
              });
              selectedFields(arr);
            })}
          >
            Download
          </WsButton>
          <WsButton variant="outlined" size="large" onClick={close}>
            cancel
          </WsButton>
        </Stack>
      </DrawerFooter>
      <WsDialog openDialog={open} onClose={() => setOpen(false)}>
        <SaveTemplateDialog
          getName={(name) => {
            saveTemplate(name);
            setOpen(false);
          }}
          close={() => setOpen(false)}
          templateName={''}
        />
      </WsDialog>
    </FormProvider>
  );
};
export default DownloadField;
